import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { apiResponseMessage } from "redux/actions/ApiMessageResponse";
import { MESSAGE_TYPE } from "redux/constants/ApiMessageResponse";

const ProtectedExternalTradeRoute = ({ children, ...reset }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const intl = useIntl();

  const { token, isPaid, subscripitionExpiryDate } = useSelector(
    ({ auth }) => auth
  );
  const isAuthenticated = () => {
    var result =
      token !== "" && token !== undefined && token !== null ? true : false;
    if (!result) {
      dispatch(
        apiResponseMessage({
          showMessage: true,
          message: intl.formatMessage({ id: "please-sign-in" }),
          messageType: MESSAGE_TYPE.ERROR,
        })
      );
    }
    return result;
    // return true;
  };
  return (
    <>
      {isAuthenticated() ? (
        isPaid &&
        subscripitionExpiryDate &&
        subscripitionExpiryDate.slice(0, 10) >
          new Date().toJSON().slice(0, 10) ? (
          // true ?
          children
        ) : (
          <Navigate to={`/external-trade-paid`} replace />
        )
      ) : (
        <Navigate to={`/login`} state={{ prevUrl: location.pathname }} />
      )}
    </>
  );
};

export default ProtectedExternalTradeRoute;
